import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent, Shell, Redirection, Logger } from '@tytapp/common';
import { UserService } from '@tytapp/user';

@Component({
  selector: 'app-assume',
  templateUrl: './assume.component.html',
  styleUrls: ['./assume.component.scss']
})
export class AssumeComponent extends BaseComponent implements OnInit {

  constructor(
    private userService : UserService,
    private redirection : Redirection,
    private shell : Shell,
    private route : ActivatedRoute
  ) { 
    super();
  }

  errorMessage : string = null;
  
  async init() {
    let userAuthToken;

    this.route.paramMap.subscribe(params => {
      let token = params.get('token');
      this.assumeUser(token);
    });
  }

  async assumeUser(token : string) {
    try {
      await this.userService.assume(token);
    } catch (e) {
      if (e.status == 401) {
        alert(`Invalid authentication token!`);
      } else {
        Logger.error(e.message || e.error, e);
        this.errorMessage = `An error occurred while attempting to assume the user: ${e.message || e.error}`;
      }
      return;
    }

    this.redirection.go('/settings/memberships');
    if (typeof window !== 'undefined') {
      this.shell.alert('Success', `You have switched to <strong>${this.userService.user.email}</strong>`);
    }
  }

}
